let originalMainHtml = '';
let originalThumbHtml = '';
document.addEventListener('DOMContentLoaded', function () {
  // Which gallery logic runs on this page?
  //  - media-product (snippets/media-product): Splide gallery rebuilt from the shade's custom.variant_image_ media. Exactly as before.
  //  - product-media-slider with gallery_ui 'media-product' ([data-media-slider]): same Splide markup/design, but its own logic.
  //    The gallery is mounted and driven by assets/hok-pdp-media-slider.js (slides to the shade's featured media, never rebuilt),
  //    so the gallery work below is skipped here. The variant info updates (price, SKU, Add to Bag, ?variant=) still run.
  //  - No Splide markup at all (other pages, or templates whose own inline script drives a Swiper gallery, e.g. new-product.liquid):
  //    do nothing. Previously this threw "Cannot read properties of null (reading 'innerHTML')" here.
  const hasSplideMarkup = !!(
    document.querySelector('#main-carousel .splide__list') && document.querySelector('#thumbnail-carousel .splide__list')
  );
  if (!hasSplideMarkup) return;
  const hasSplideGallery = !document.querySelector('.product-gallery-custom[data-media-slider]');

  if (hasSplideGallery) {
    // PDP: when the gallery was rendered server-side for the selected variant (data-ssr-variant), the product's default
    // gallery markup is kept in <template> elements so restoreOriginalGallery() still restores the default media.
    const ssrVariantId = (document.querySelector('#main-carousel') || {}).dataset
      ? document.querySelector('#main-carousel').dataset.ssrVariant
      : '';
    const defaultMainTpl = document.getElementById('hpdp-default-main');
    const defaultThumbTpl = document.getElementById('hpdp-default-thumbs');
    originalMainHtml = defaultMainTpl
      ? defaultMainTpl.innerHTML
      : document.querySelector('#main-carousel .splide__list').innerHTML;
    originalThumbHtml = defaultThumbTpl
      ? defaultThumbTpl.innerHTML
      : document.querySelector('#thumbnail-carousel .splide__list').innerHTML;
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    const selectedVariant = variantId
      ? document.querySelector(`.swatch-element input[type="radio"][value="${variantId}"]`)
      : document.querySelector('.swatch-element input[type="radio"]:checked');
    if (selectedVariant) {
      const images = JSON.parse(selectedVariant.dataset.images || '[]');
      if (images.length && ssrVariantId && String(selectedVariant.value) === String(ssrVariantId)) {
        // Gallery already server-rendered with this variant's images: just mount it (no rebuild, no image swap).
        initializeSplide();
      } else if (images.length) {
        updateVariantGallery(images);
      } else {
        initializeSplide();
      }
    } else {
      initializeSplide();
    }
  }
  document.addEventListener('change', function (e) {
    const variantInput = e.target.closest('.swatch-element input[type="radio"]');
    if (!variantInput) return;
    // Shade radios inside the quick-view drawer (product cards' "Select Shade") belong to another product:
    // they must not change this page's shade label, gallery or URL.
    if (variantInput.closest('.quick-view-slide-container')) return;
    const swatchElement = variantInput.closest('.swatch-element');
    const variantTag = document.querySelector('.product_swatch_colors_value');
    if (variantTag) {
      variantTag.textContent = swatchElement.dataset.value;
    }
    const productInfo = variantInput.closest('.l-pdp-product_info_inner');
    if (productInfo) {
      const price = variantInput.getAttribute('variantPrice');
      const comparePrice = variantInput.getAttribute('variantRackRate');
      const availability = variantInput.getAttribute('is_variant_available');
      const variantId = variantInput.value;
      const sku = variantInput.getAttribute('variant-sku');
      const discountPer = variantInput.getAttribute('discount');
      const priceElement = productInfo.querySelector('.rack-rate');
      const salePriceElement = productInfo.querySelector('.saling_price');
      const discount = productInfo.querySelector('.discount_label ');
      console.log(discountPer, "discountPer")
      if (discount) {
        discount.textContent = discountPer;
      }
      if (priceElement) {
        priceElement.textContent = comparePrice;
      }
      if (salePriceElement) {
        salePriceElement.textContent = price;
      }
      const skuElement = document.querySelector('.b-pdp_accordion-product_code');
      if (skuElement) {
        skuElement.textContent = sku;
      }
      const addToCartBtn = productInfo.querySelector('#main-product-handle-btn');
      if (addToCartBtn) {
        addToCartBtn.setAttribute('product_variantid', variantId);
        if (availability === 'true') {
          addToCartBtn.textContent = 'Add to Bag';
          addToCartBtn.removeAttribute('disabled');
        } else {
          addToCartBtn.textContent = 'Out Of Stock';
          addToCartBtn.setAttribute('disabled', 'disabled');
        }
      }
      window.history.replaceState(
        null,
        null,
        `${window.location.pathname}?variant=${variantId}`
      );
    }
    // product-media-slider logic: nothing to rebuild here — hok-pdp-media-slider.js slides to the shade's featured media.
    if (!hasSplideGallery) return;
    const images = JSON.parse(variantInput.dataset.images || '[]');
    if (images.length) {
      updateVariantGallery(images);
    } else {
      restoreOriginalGallery();
    }
  });
});
function initializeSplide() {
  // Safe to call more than once: any previous instance on these elements is destroyed first (no duplicate arrows,
  // pagination, listeners or Splide instances), and nothing happens when the gallery markup is not on the page.
  if (!document.querySelector('#main-carousel') || !document.querySelector('#thumbnail-carousel')) return;
  [window.mainSplide, window.thumbSplide].forEach(function (instance) {
    if (instance && instance.state && !instance.state.is(7)) instance.destroy(true); // 7 = DESTROYED
  });
  window.mainSplide = new Splide('#main-carousel', {
    type: 'slide',
    rewind: true,
    pagination: false,
    arrows: true,
     breakpoints: {
      600: {
       pagination: true,
      }
    }
  });
  window.thumbSplide = new Splide('#thumbnail-carousel', {
    direction: 'ttb',
    height: '640px',
    fixedWidth: 94,
    fixedHeight: 94,
    gap: 10,
    arrows: false,
    pagination: false,
    isNavigation: true,
    breakpoints: {
        1800: {
      height: '640px' // 1401px to 1600px
    },
      1600: {
      height: '530px' // 1401px to 1600px
    },

    1400: {
      height: '665px' // 1400px aur usse niche
    },
     1024: {
      height: '400px' 
    },
      600: {
        fixedWidth: 70,
        fixedHeight: 70,
        direction: 'ltr'
      }
    }
  });
  window.mainSplide.sync(window.thumbSplide);
  window.mainSplide.mount();
  window.thumbSplide.mount();
}
function updateVariantGallery(images) {
  window.mainSplide?.destroy(true);
  window.thumbSplide?.destroy(true);

  const isVideo = url => /\.(mp4|webm|mov|m3u8)(\?|#|$)/i.test(url);

  const slides = images.map(url => `
    <li class="splide__slide">
      ${
        isVideo(url)
          ? `<video autoplay loop muted playsinline preload="metadata" class="w-100 h-auto">
              <source src="${url}" type="video/mp4">
            </video>`
          : `<img src="${url}" alt="" loading="lazy">`
      }
    </li>
  `).join('');

  document.querySelector('#main-carousel .splide__list').innerHTML = slides;
  document.querySelector('#thumbnail-carousel .splide__list').innerHTML = slides;

  initializeSplide();
  window.mainSplide.go(0);
}
function restoreOriginalGallery() {
  window.mainSplide?.destroy(true);
  window.thumbSplide?.destroy(true);
  document.querySelector('#main-carousel .splide__list').innerHTML =
    originalMainHtml;
  document.querySelector('#thumbnail-carousel .splide__list').innerHTML =
    originalThumbHtml;
  initializeSplide();
  window.mainSplide.go(0);
}